import axios from 'axios';
import _ from 'lodash';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import {
  INGSIGHT_360_ATTITUDE_REPORT_NAME,
  INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
  INGSIGHT_360_MEDIA_REPORT_NAME,
  INGSIGHT_360_BRANDS_REPORT_NAME,
  INGSIGHT_360_PROFILE_REPORT_NAME,
  INGSIGHT_360_REPORTVIEW_REPORT_NAME,
  INGSIGHT_360_HEADERINFO_REPORT_NAME,
  INSIGHT_360_NETWORK_ERROR_DESC,
  INSIGHT_360_GENERAL_ERROR,
  INSIGHT360_EXPLORE,
  INSIGHT360_REPORTS,
  INSIGHT360_PERSONA_CREATOR,
  UPDATE_FOR_SEGMENT_LABEL,
  UPDATE_FOR_DEFINITION_LABEL,
  SEGMENT_FILTER_LENGTH,
  PREFERENCE_BRAND_CATALYST,
  PREFERENCE_BRAND_CATALYST_AUTO_UPDATE,
  PREFERENCE_STUDY,
  INSIGHT_360_NOTABLE_TOP_VALUE,
  INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
} from '../constants';
import {
  DATA_SAVE_SERVER_ERROR,
  ATTITUDINAL_TEMPLATE_NAME_SAVE_SUCCESS,
} from '../messages/messages';
import {
  handleEmptyResponse,
  getErrorCategoryLabel,
  getFilterConfig,
  setBrandCatalystDataOnSave,
  getBrandAndMediaFiltersFromPreferences,
  getSortByKey,
  getDeepDiveSortByKey,
} from '../util/Insight360Utils';
import { formatJson, getFiltersForGivenFamilyId, getStudyFromStudies } from '../util/CommonUtils';
import { toastSuccess, toastWarning } from '../util/toastUtils';

function dispatchgetResponseData(
  response,
  reportName,
  isPersonaCreator,
  dispatch,
  isSectionSort,
  isProfileBrandAndMedia,
) {
  switch (reportName) {
    case INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME:
      dispatch({
        type: types.SHOW_BRAND_INSIGHT360_PERSONAS_DEMOGRAPHICS,
        payload: {
          data: response.data.data,
          isPersonaCreator,
          isSectionSort,
        },
      });
      break;
    case INGSIGHT_360_ATTITUDE_REPORT_NAME:
      dispatch({
        type: types.SHOW_BRAND_INSIGHT360_PERSONAS_ATTITUDES,
        payload: {
          data: response.data.data,
          isPersonaCreator,
          isSectionSort,
        },
      });
      break;
    case INGSIGHT_360_BRANDS_REPORT_NAME:
      dispatch({
        type: isProfileBrandAndMedia === true ? types.SHOW_INSIGHT360_PROFILE_PERSONAS_BRANDS :
        types.SHOW_BRAND_INSIGHT360_PERSONAS_BRANDS,
        payload: { data: response.data,
          isPersonaCreator,
          isSectionSort,
         },
      });
      break;
    case INGSIGHT_360_MEDIA_REPORT_NAME:
      dispatch({
        type: isProfileBrandAndMedia === true ? types.SHOW_INSIGHT360_PROFILE_MEDIA :
        types.SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA,
        payload: { data: response.data,
          isPersonaCreator,
          isSectionSort,
         },
      });
      break;
    case INGSIGHT_360_PROFILE_REPORT_NAME:
      dispatch({
        type: types.SHOW_INSIGHT360_PERSONAS_PROFILES,
        payload: {
          data: response.data.data,
          isPersonaCreator,
          isSectionSort,
        },
      });
      break;
    case INGSIGHT_360_REPORTVIEW_REPORT_NAME:
      dispatch({
        type: types.SHOW_INSIGHT360_PERSONAS_REPORTVIEW,
        payload: { data: response.data.data },
      });
      break;
    default: break;
  }
}
function getExcludeProfileAttitudesExps(getState) {
//   const preferencesStudyFamilyId = getState.preferences
// .userPreferences[PREFERENCE_BRAND_CATALYST][PREFERENCE_BRAND_CATALYST_STUDY_FAMILY];
  const bcStudyFamily = getState.study.insight360study.studyFamilyId;
  const attModuleList = getState.insight360.excludesProfileAttList;
  const indexVal = _.findIndex(attModuleList, { studyFamilyId: bcStudyFamily });
  const expressionList = [];
  if ((indexVal !== undefined && indexVal > -1) && !_.isEmpty(attModuleList[indexVal].profileAttStatements)) {
    _.forEach(attModuleList[indexVal].profileAttStatements, value => {
      expressionList.push(value.expression);
    });
  }
  return expressionList;
}

export function getInsight360Personas(
  { token, uid, accountId, personaLabels, personaExpressions },
  reportName,
  top,
  questions,
  isPersonaCreator,
  isSectionSort,
  isProfileBrandAndMedia,
) {
  return (dispatch, getState) => {
    const reportAutoUpdateFlag = _.isEmpty(getState().insight360
    .bcSessionConfiguration) ? false : getState().insight360
    .bcSessionConfiguration[PREFERENCE_BRAND_CATALYST][PREFERENCE_BRAND_CATALYST_AUTO_UPDATE];
    const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
    const base = getState().insight360.insight360Base;
    const studySource = getState().study.insight360study.ss;
    const filterConfig = getFilterConfig(getState(), reportName);
    const vPctVal = isPersonaCreator
      ? getState().insight360.personaCreator.inight360VerticalPercent
      : getState().insight360.inight360VerticalPercent;
    const productNo = getState().study.insight360study.pn;
    const studyFamilyId = getState().study.insight360study.studyFamilyId;
    let selectedFiltersBrands = [];
    let selectedFiltersMedia = [];
     selectedFiltersBrands = isPersonaCreator
      ? getFiltersForGivenFamilyId(getState().insight360.personaCreator.selectedFilters.brands, studyFamilyId)
      : getFiltersForGivenFamilyId(getState().insight360.selectedFilters.brands, studyFamilyId);
     selectedFiltersMedia = isPersonaCreator
      ? getFiltersForGivenFamilyId(getState().insight360.personaCreator.selectedFilters.media, studyFamilyId)
      : getFiltersForGivenFamilyId(getState().insight360.selectedFilters.media, studyFamilyId);

      if (isProfileBrandAndMedia === true) {
        selectedFiltersBrands = isPersonaCreator
        ? getFiltersForGivenFamilyId(getState().insight360.personaCreator.topMediaBrandSelectedFilters.brands,
         studyFamilyId)
        : getFiltersForGivenFamilyId(getState().insight360.topMediaBrandSelectedFilters.brands, studyFamilyId);
        selectedFiltersMedia = isPersonaCreator
        ? getFiltersForGivenFamilyId(getState().insight360.personaCreator.topMediaBrandSelectedFilters.media,
         studyFamilyId)
        : getFiltersForGivenFamilyId(getState().insight360.topMediaBrandSelectedFilters.media, studyFamilyId);
      }
    const subCategories = [];
    if (reportName === INGSIGHT_360_BRANDS_REPORT_NAME && selectedFiltersBrands.length > 0) {
        selectedFiltersBrands.forEach(brandItem => {
          subCategories.push(brandItem.value);
        });
    } else if (reportName === INGSIGHT_360_MEDIA_REPORT_NAME && selectedFiltersMedia.length > 0) {
        selectedFiltersMedia.forEach(mediaItem => {
          subCategories.push(mediaItem.value);
        });
    }

    let data = {};
    if (base !== undefined && !isPersonaCreator) {
      data = {
        reportName,
        baseExpression: base.baseExpression,
        baseLabel: base.baseLabel,
        personaLabels,
        personaExpressions,
        top,
        questions,
        filterConfig,
        // vpctFilter: vPctVal,
        productNo,
        subCategories,
      };
    } else {
      data = {
        reportName,
        personaLabels,
        personaExpressions,
        top,
        questions,
        filterConfig,
        // vpctFilter: vPctVal,
        productNo,
        subCategories,
      };
    }
    data.sortBy = getSortByKey(reportName, getState(), isPersonaCreator, isProfileBrandAndMedia);
    if (reportName === '360PROF' && !_.isEmpty(getState().preferences
    .userPreferences)) {
      const expressionList = getExcludeProfileAttitudesExps(getState());
      data.excludeProfileAttitudesExps = expressionList;
    }
    if (reportName === INGSIGHT_360_REPORTVIEW_REPORT_NAME && (reportAutoUpdateFlag === false)) {
      data.filterConfig = {
        sample: '>0',
        pct: '>0',
        index: '>0',
      };
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        const configData = JSON.parse(response.config.data);
        if (response.status === 400 && response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          if (
            configData.reportName === '360BRANDS' ||
            configData.reportName === '360MEDIA'
          ) {
            response.data = handleEmptyResponse(configData, studySource);
          } else {
            response.data.data = handleEmptyResponse(configData, studySource);
          }
          toastWarning(
            `${getErrorCategoryLabel(configData.reportName)} : ${
              response.data.message !== undefined
                ? response.data.message
                : INSIGHT_360_GENERAL_ERROR
            }`,
          );
        }
        dispatchgetResponseData(
          response,
          reportName,
          isPersonaCreator,
          dispatch,
          isSectionSort,
          isProfileBrandAndMedia,
        );
      })
      .catch(response => {
        console.warn(response);
        if (response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          response.data = {};
          if (
            configData.reportName === '360BRANDS' ||
            configData.reportName === '360MEDIA'
          ) {
            response.data = handleEmptyResponse(configData, studySource);
          } else {
            response.data.data = handleEmptyResponse(configData, studySource);
          }
          toastWarning(
            `${getErrorCategoryLabel(
              configData.reportName,
            )} : ${INSIGHT_360_NETWORK_ERROR_DESC}`,
          );
          dispatchgetResponseData(
            response,
            configData.reportName,
            isPersonaCreator,
            dispatch,
            isSectionSort,
            isProfileBrandAndMedia,
          );
        }
      });
  };
}

export function updateInsight360PersonasFilter(
  { token, uid, accountId, personaLabels, personaExpressions, index },
  reportName,
  isBaseCall,
  top,
  questions,
  isProfileBrandAndMedia,
) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    let filterConfig = getFilterConfig(getState(), reportName);
    if (reportName === INGSIGHT_360_HEADERINFO_REPORT_NAME) {
      filterConfig = {
        sample: '>0',
        pct: '>0',
        index: '>0',
      };
    }
    const base = getState().insight360.insight360Base;
    const vPctVal = getState().insight360.inight360VerticalPercent;
    const productNo = getState().study.insight360study.pn;
    const studySource = getState().study.insight360study.ss;
    const studyFamilyId = getState().study.insight360study.studyFamilyId;
    const subCategories = [];
    if (reportName === INGSIGHT_360_BRANDS_REPORT_NAME && !isProfileBrandAndMedia) {
      const selectedFilters = getFiltersForGivenFamilyId(getState().insight360.selectedFilters.brands, studyFamilyId);
      selectedFilters.map(brandItem => {
        subCategories.push(brandItem.value);
      });
    } else if (reportName === INGSIGHT_360_MEDIA_REPORT_NAME && !isProfileBrandAndMedia) {
      const selectedFilters = getFiltersForGivenFamilyId(getState().insight360.selectedFilters.media, studyFamilyId);
      selectedFilters.map(mediaItem => {
        subCategories.push(mediaItem.value);
      });
    };
    if (reportName === INGSIGHT_360_BRANDS_REPORT_NAME && isProfileBrandAndMedia === true) {
      const selectedFilters = getFiltersForGivenFamilyId(getState().insight360.topMediaBrandSelectedFilters.brands,
       studyFamilyId);
      selectedFilters.map(brandItem => {
        subCategories.push(brandItem.value);
      });
    } else if (reportName === INGSIGHT_360_MEDIA_REPORT_NAME && isProfileBrandAndMedia === true) {
      const selectedFilters = getFiltersForGivenFamilyId(getState().insight360.topMediaBrandSelectedFilters.media,
       studyFamilyId);
      selectedFilters.map(mediaItem => {
        subCategories.push(mediaItem.value);
      });
    };
   
    let data = {};
  
    if (base !== undefined) {
      data = {
        reportName,
        baseExpression: base.baseExpression,
        baseLabel: base.baseLabel,
        personaLabels,
        personaExpressions,
        top,
        questions,
        filterConfig,
        productNo,
        subCategories,
      };
    } else {
      data = {
        reportName,
        personaLabels,
        personaExpressions,
        top,
        questions,
        filterConfig,
        productNo,
        subCategories,
      };
    }
    data.sortBy = getSortByKey(reportName, getState(), null, isProfileBrandAndMedia);
    if (reportName === '360PROF' && !_.isEmpty(getState().preferences
        .userPreferences)) {
      const expressionList = getExcludeProfileAttitudesExps(getState());
      data.excludeProfileAttitudesExps = expressionList;
    }
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 400 && response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          if (
            configData.reportName === '360BRANDS' ||
            configData.reportName === '360MEDIA'
          ) {
            response.data = handleEmptyResponse(configData, studySource);
          } else {
            response.data.data = handleEmptyResponse(configData, studySource);
          }
          toastWarning(
            `${getErrorCategoryLabel(configData.reportName)} : ${
              response.data.message !== undefined
                ? response.data.message
                : INSIGHT_360_GENERAL_ERROR
            }`,
          );
        }
        dispatchUpdateResponseData(
          response,
          reportName,
          dispatch,
          index,
          isBaseCall,
          personaExpressions,
          isProfileBrandAndMedia,
        );
      })
      .catch(response => {
        console.warn(response);
        if (response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          response.data = {};
          if (
            configData.reportName === '360BRANDS' ||
            configData.reportName === '360MEDIA'
          ) {
            response.data = handleEmptyResponse(configData, studySource);
          } else {
            response.data.data = handleEmptyResponse(configData, studySource);
          }
          toastWarning(
            `${getErrorCategoryLabel(
              configData.reportName,
            )} : ${INSIGHT_360_NETWORK_ERROR_DESC}`,
          );
          dispatchUpdateResponseData(
            response,
            configData.reportName,
            dispatch,
            index,
            isBaseCall,
            personaExpressions,
            isProfileBrandAndMedia,
          );
        }
      });
  };
}

function dispatchUpdateResponseData(
  response,
  reportName,
  dispatch,
  index,
  isBaseCall,
  personaExpressions,
  isProfileBrandAndMedia,
) {
  switch (reportName) {
    case INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME:
      if (index !== undefined) {
        dispatch({
          type: types.UPDATE_BRAND_INSIGHT360_DEMOGRAPHICS_PERSONAS,
          payload: [...response.data.data, { index }],
        });
      } else {
        dispatch({
          type: types.SHOW_BRAND_INSIGHT360_PERSONAS_DEMOGRAPHICS,
          payload: { data: response.data.data, isBaseCall },
        });
      }
      break;
    case INGSIGHT_360_ATTITUDE_REPORT_NAME:
      if (index !== undefined) {
        dispatch({
          type: types.UPDATE_BRAND_INSIGHT360_ATTITUDES_PERSONAS,
          payload: [...response.data.data, { index }],
        });
      } else {
        dispatch({
          type: types.SHOW_BRAND_INSIGHT360_PERSONAS_ATTITUDES,
          payload: { data: response.data.data, isBaseCall },
        });
      }
      break;
    case INGSIGHT_360_PROFILE_REPORT_NAME:
      if (index !== undefined) {
        dispatch({
          type: types.UPDATE_BRAND_INSIGHT360_PROFILES,
          payload: [...response.data.data, { index }],
        });
      } else {
        dispatch({
          type: types.SHOW_INSIGHT360_PERSONAS_PROFILES,
          payload: { data: response.data.data, isBaseCall },
        });
      }
      break;
    case INGSIGHT_360_BRANDS_REPORT_NAME:
      // for Media and brands data is available at response.data level unlike others
      if (index !== undefined) {
        dispatch({
          type: isProfileBrandAndMedia === true ? types.UPDATE_INSIGHT360_PROFILE_BRANDS :
          types.UPDATE_BRAND_INSIGHT360_BRANDS,
          payload: [...response.data, { index }],
        });
      } else {
        dispatch({
          type: isProfileBrandAndMedia === true ? types.SHOW_INSIGHT360_PROFILE_PERSONAS_BRANDS :
          types.SHOW_BRAND_INSIGHT360_PERSONAS_BRANDS,
          payload: { data: response.data, isBaseCall },
        });
      }
      break;
    case INGSIGHT_360_MEDIA_REPORT_NAME:
      // for Media and brands data is available at response.data level unlike others
      if (index !== undefined) {
        dispatch({
          type: isProfileBrandAndMedia === true ? types.UPDATE_INSIGHT360_PROFILE_MEDIA :
          types.UPDATE_BRAND_INSIGHT360_MEDIA,
          payload: [...response.data, { index }],
        });
      } else {
        dispatch({
          type: isProfileBrandAndMedia === true ? types.SHOW_INSIGHT360_PROFILE_MEDIA :
          types.SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA,
          payload: { data: response.data, isBaseCall },
        });
      }
      break;
    case INGSIGHT_360_HEADERINFO_REPORT_NAME:
      if (
        index !== undefined &&
        !_.isEmpty(response.data) &&
        !_.isEmpty(response.data.data) &&
        response.data.data[0] !== undefined &&
        response.data.data[0].headers !== undefined
      ) {
        dispatch({
          type: types.UPDATE_BRAND_INSIGHT360_HEADERINFO,
          payload: {
            ...response.data.data[0].headers[1],
            expressions: personaExpressions,
            index,
            isBaseCall,
          },
        });
      } else if (
        !_.isEmpty(response.data) &&
        !_.isEmpty(response.data.data) &&
        response.data.data[0] !== undefined &&
        response.data.data[0].headers !== undefined
      ) {
        dispatch({
          type: types.UPDATE_BRAND_INSIGHT360_HEADERINFO,
          payload: {
            ...response.data.data,
            expressions: personaExpressions,
            isBaseCall,
          },
        });
      }
      break;
    default: break;
  }
}

export function get360Study(token, userId, accountId) {
  // const url = `${urls.ROOT_URL}/si360/product/${userId}/${accountId}`;
  const url = `${urls.ROOT_URL}/users/${userId}/${accountId}/bc-studies`;
  return (dispatch, getState) => axios({
    url,
    method: 'get',
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
    responseType: 'json',
  })
    .then(response => {
      if (response.data.data && response.data.data.length === 0) {
        dispatch({
          type: types.NO_BC_STUDIES,
          payload: false,
        });
        return false;
      }
      const preferences = getState().preferences && getState().preferences.userPreferences ? getState().preferences.userPreferences : null;
      let selectedStudy = response.data.data[0].sl[0];
      if (!_.isEmpty(preferences) && preferences[PREFERENCE_BRAND_CATALYST] !== undefined &&
      preferences[PREFERENCE_BRAND_CATALYST][PREFERENCE_STUDY] !== undefined &&
      preferences[PREFERENCE_BRAND_CATALYST][PREFERENCE_STUDY] !== -1) {
        selectedStudy = getStudyFromStudies(response.data.data, preferences[PREFERENCE_BRAND_CATALYST][PREFERENCE_STUDY]);
      }

      new Promise(resolve => {
        dispatch({
          type: types.GET_360_STUDY,
          payload: response.data.data,
          study: selectedStudy,
        });
        resolve();
      }).then(() => {
        setBrandCatalystDataOnSave(_.cloneDeep(preferences._bc), dispatch, getState);
      });

      return selectedStudy;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
}

export function get360DemographicsFilter(token, productNo) {
  const url = `${urls.ROOT_URL}/si360/filters/360DEMOS/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.GET_360_DEMOGRAPHICS_FILTER_OPTIONS,
          payload: response.data,
        });
      })
      .catch(response => console.warn(response));
  };
}

export function set360HeaderInfo(
  token,
  uid,
  accountId,
  headerInfo,
  reportName,
  selectedTab,
) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().insight360.insight360Base;
    const productNo = getState().study.insight360study.pn;
    let data = {
      reportName,
      personaLabels: headerInfo.label,
      personaExpressions: headerInfo.expression,
      productNo,
      filterConfig: {
        sample: '>0',
        pct: '>0',
        index: '>0',
      },
    };
    if (
      base !== undefined &&
      (selectedTab === INSIGHT360_EXPLORE || selectedTab === INSIGHT360_REPORTS)
    ) {
      data = {
        ...data,
        ...{
          baseExpression: base.baseExpression,
          baseLabel: base.baseLabel,
        },
      };
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 400 && _.isEmpty(response.data.data)) {
          /* dispatch({
            type: types.INVALID_PERSONA_SELECTED,
            payload: {...response.data.message}
          }) */
          return response;
        } 
          if (
            selectedTab === INSIGHT360_EXPLORE ||
            selectedTab === INSIGHT360_REPORTS
          ) {
            dispatch({
              type: types.SAVE_BRAND_INSIGHT360_HEADER_INFO,
              payload: {
                ...response.data.data[0].headers[1],
                expressions: headerInfo.expression,
                expressionsId: headerInfo.personaExpressionsId,
                definationId: headerInfo.definationId,
              },
            });
          } else if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
            dispatch({
              type: types.SAVE_PERSONA_CREATOR_HEADER_INFO,
              payload: {
                ...response.data.data[0].headers[1],
                expressions: headerInfo.expression,
              },
            });
          }

          setTimeout(() => {
            return response;
          }, 0);
        
      })
      .catch(response => console.warn(response));
  };
}

export const set360Base = baseInfo => ({
  type: types.SAVE_BRAND_INSIGHT360_BASE_INFO,
  payload: baseInfo,
});

export const set360DemographicsFilter = indexAndFilter => ({
  type: types.SAVE_BRAND_INSIGHT360_PERSONA_FILTER,
  payload: indexAndFilter,
});

export const resetAll = () => {
  return (dispatch, getState) => {
    dispatch({
      type: types.RESET_ALL_INSIGHT360,
      payload: getBrandAndMediaFiltersFromPreferences(getState().preferences),
    });
  };
};

export const removeDemographic = indexToRemove => ({
  type: types.REMOVE_DEMOGRAPHIC,
  payload: indexToRemove,
});

export const removePersonaCreator = () => {
  return (dispatch, getState) => {
    dispatch({
      type: types.REMOVE_PERSONA_CREATOR,
      payload: getBrandAndMediaFiltersFromPreferences(getState().preferences),
    });
  };
};

export const updateAttitudeAgreeChoice = (choice, selectedTab) => {
  return dispatch => {
    if (selectedTab === INSIGHT360_EXPLORE) {
      dispatch({
        type: types.UPDATE_ATTITUDE_INSIGHT_AGREE_CHOICE,
        payload: choice,
      });
    } else if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      dispatch({
        type: types.UPDATE_CREATOR_ATTITUDE_INSIGHT_AGREE_CHOICE,
        payload: choice,
      });
    }
  };
};


export function getDictionaryTreeLoad(
  token,
  uid,
  accountId,
  productNo,
  nodeID,
) {
  const url = `${urls.ROOT_URL}${urls.BC_TREELOADEX}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
      },
    })
      .then(response =>
        dispatch({
          type: types.GET_360_REPORTS_DICTIONARY_TREE_LOAD,
          payload: response.data,
          nodeID,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export function searchDictionaryReportTree(
  token,
  uid,
  accountId,
  productNo,
  searchType,
  searchText,
) {
 const url = `${urls.ROOT_URL}${urls.BC_TREELOADEX_SEARCH}`;
  return dispatch => {
    const nodeID = 0;
    axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
      data: {
        uid: `${uid}`,
        accountId: `${accountId}`,
        productNo: `${productNo}`,
        searchType: `${searchType}`,
        searchText: `${searchText}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.SEARCH_360_REPORTS_DICTIONARY_TREE_LOAD,
          payload: response.data,
          nodeID,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export const set360DictionarySelectedCategory = category => ({
  type: types.SAVE_360_DICTIONARY_SELECTED_CATEGORY,
  payload: category,
});

export function getDefinitionTreeLoad(token, ssid, accountId, productNo) {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_360_REPORTS_DEFINITION_TREE_LOAD,
          payload: response.data,
          productNo,
        }),
      )
      .catch(response => console.warn(response));
  };
}

export function getDefinitionTargetLoad(accountId, definitionId) {
  const url = `${
    urls.API_GATEWAY_URL
  }/api/dictionary-service/definitions/expressions/${accountId}/${definitionId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_360_REPORTS_DEFINITION_TARGET_LOAD,
          payload: response.data,
        }),
      )
      .catch(response => console.warn(response));
  };
}

// export const updatePersonaFixedHeaderChoice = (choice) => ({
//   type: types.UPDATE_PERSONA_FIXED_HEADER_CHOICE,
//   payload: choice
// })

export function validateBaseInfo(
  token,
  uid,
  accountId,
  headerInfo,
  reportName,
) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const productNo = getState().study.insight360study.pn;
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        reportName,
        personaLabels: [headerInfo.baseLabel],
        personaExpressions: [headerInfo.baseExpression],
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      },
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 400 && _.isEmpty(response.data.data)) {
          return response;
        } 
          return response;
        
      })
      .catch(response => {
        console.warn(response);
      });
  };
}


// getting notable characters service call..

export function getnotableCharacters(token, uid, accountId, personaLabels,
  personaExpressions, top) {
  return (dispatch, getState) => {
    const url = `${urls.ROOT_URL}/si360/cluster-segments/${uid}/${accountId}`;
    const productNo = getState().study.insight360study.pn;
    return axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
      withCredentials: true,
      responseType: 'json',
      data: {
        personaLabels: [personaLabels],
        personaExpressions: [personaExpressions],
        productNo,
        top,
      },
    })
      .then(response => {
        if (response.status === 400) {
          return false;
          toastWarning('Failed to fetch notable characters');
        }
      });
  };
}

export function createClusterSegments(
  { token, uid, accountId, personaLabels, personaExpressions },
  segmentCount = 3,
  clusterStatExpressions = [],
  selctedExpressionObject = [],
  selectedAttitudinal = {},
  top = INSIGHT_360_NOTABLE_TOP_VALUE,
) {
  return (dispatch, getState) => {
    const url = `${urls.ROOT_URL}/si360/cluster-segments/${uid}/${accountId}`;
    const productNo = getState().study.insight360study.pn;
    return axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
      withCredentials: true,
      responseType: 'json',
      data: {
        personaLabels: [personaLabels],
        personaExpressions: [personaExpressions],
        segmentCount,
        clusterStatExpressions,
        productNo,
        top,
      },
    })
      .then(response => {
        if (response.status === 400) {
          return false;
          toastWarning('Failed to fetch cluster segments');
        }
        dispatch({
          type: types.PERSONA_CREATOR_360_CLUSTER_SEGMENTS,
          payload: response.data,
          segmentCount,
          clusterStatExpressions,
          selctedExpressionObject,
          selectedAttitudinal,
        });

        return true;
      })
      .catch(response => {
        console.warn(response.data);
        toastWarning('Failed to fetch cluster segments');
        return false;
      });
  };
}

export function validateHeaderResponseValue(
  { token, uid, accountId, personaLabels, personaExpressions, index },
  reportName,
  isBaseCall,
  baseInfo,
  top,
  questions,
) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const base =
      baseInfo !== undefined ? baseInfo : getState().insight360.insight360Base;
    const productNo = getState().study.insight360study.pn;
    const studySource = getState().study.insight360study.ss;
    let data = {};
    if (base !== undefined) {
      data = {
        reportName,
        baseExpression: base.baseExpression,
        baseLabel: base.baseLabel,
        personaLabels,
        personaExpressions,
        top,
        questions,
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      };
    } else {
      data = {
        reportName,
        personaLabels,
        personaExpressions,
        top,
        questions,
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      };
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 400 && response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          response.data.data = handleEmptyResponse(configData, studySource);
          toastWarning(
            `${
              response.data.message !== undefined
                ? response.data.message
                : INSIGHT_360_GENERAL_ERROR
            }`,
          );
          return false;
        }
        dispatchUpdateResponseData(
          response,
          reportName,
          dispatch,
          index,
          isBaseCall,
          personaExpressions,
        );
        return true;
      })
      .catch(response => {
        console.warn(response);
        if (response.config !== undefined) {
          const configData = JSON.parse(response.config.data);
          response.data = {};
          response.data.data = handleEmptyResponse(configData, studySource);
          toastWarning(`${INSIGHT_360_NETWORK_ERROR_DESC}`);
          dispatchUpdateResponseData(
            response,
            configData.reportName,
            dispatch,
            index,
            isBaseCall,
            personaExpressions,
          );
          return false;
        }
      });
  };
}

export function fetchClusterStatements(token, uid, accountId, productNo) {
  const url = `${
    urls.ROOT_URL
  }/si360/cluster-statements/${uid}/${accountId}/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
      withCredentials: true,
      responseType: 'json',
    }).then(response => {
      dispatch({
        type: types.SAVE_CREATOR_ATTITUDE_INSIGHT_DATA,
        attitudesList: formatJson(response.data.data, SEGMENT_FILTER_LENGTH),
      });
    });
  };
}

export const setSegmentScreen = flag => ({
  type: types.SET_IS_PERSONA_CREATOR_SEGMENT_SCREEN,
  payload: flag,
});

export function updatePersonaCreatorSegmentsData(selectedSegments) {
  return dispatch =>
    new Promise(resolve => {
      dispatch({
        type: types.UPDATE_PERSONA_CREATOR_SEGMENTS,
        payload: selectedSegments,
      });
      resolve(true);
    });
}

export const saveUpdatedData = (
  token,
  uid,
  accountId,
  data,
  updateFor,
  callbackFn,
  callbackFnForDefination,
) => {
  const url = `${
    urls.ROOT_URL
  }/si360/save-cluster-segments/${uid}/${accountId}`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          dispatchResponseDataToReducer(response, updateFor, dispatch);
          if (typeof callbackFnForDefination !== 'undefined') {
            callbackFnForDefination();
          }

          return callbackFn(true);
        }
        if (response.status === 400) {
          toastWarning(
            generateFailedErrorMessage(updateFor, response.data.message),
          );
          callbackFn(false);
          return response;
        }
      })
      .catch(response => {
        toastWarning(
          generateFailedErrorMessage(updateFor, response.data.message),
        );
        callbackFn(false);
      });
  };
};

function dispatchResponseDataToReducer(response, updateFor, dispatch) {
  switch (updateFor) {
    case UPDATE_FOR_SEGMENT_LABEL:
      dispatch({
        type: types.UPDATE_MODIFY_SEGMENT_NAME,
        data: JSON.parse(response.config.data).segments[0],
      });
      break;
    case UPDATE_FOR_DEFINITION_LABEL:
      dispatch({
        type: types.UPDATE_PERSONA_CREATOR_DEFINITION_NAME,
        data: JSON.parse(response.config.data).defName,
      });
      break;
    default: break;
  }
}

const generateFailedErrorMessage = (updateFor, message) => {
  switch (updateFor) {
    case UPDATE_FOR_SEGMENT_LABEL:
      return message || DATA_SAVE_SERVER_ERROR;
    case UPDATE_FOR_DEFINITION_LABEL:
      return message || DATA_SAVE_SERVER_ERROR;
    default: break;
  }
};

export function set360VerticalPercent(vPct, isPersonaCreator) {
  return dispatch =>
    new Promise(resolve => {
      dispatch({
        type: types.SAVE_BRAND_INSIGHT360_VERTICAL_PERCENT,
        payload: { vPct, isPersonaCreator },
      });
      resolve(true);
    });
}

export const setPersonaCreatorPopupDisplay = displayVal => ({
  type: types.SET_PERSONA_CREATOR_POPUP_DISPLAY,
  payload: displayVal,
});

export const set360ReporterSortInfo = sortInfo => ({
  type: types.SET_360_REPORTER_SORT_INFO,
  payload: sortInfo,
});

export const set360ReportsSelectionVariables = data => ({
  type: types.SET_360REPORTS_VARIABLE_SELECTION,
  payload: data,
});

export const set360Study = data => ({
  type: types.SET_360_STUDY,
  payload: data,
});

export const saveDefinitionData = (
  token,
  uid,
  accountId,
  productNo,
  data,
  callbackFn,
  callbackFnForDefinition,
  indexToUpdate,
  category,
  updateBaseFlag,
) => {
  const url = `${
    urls.ROOT_URL
  }/si360/save-persona/${uid}/${accountId}/${productNo}`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          if (updateBaseFlag !== true) {
            const personaLabel = [];
            const personaLabelID = [];
            response.data.data.expressions.map(expression => {
              if (data.expressions[0].title === expression.title) {
                personaLabel.push(expression.title);
                personaLabelID.push(expression.id);
              }
            });
            dispatch({
              type: types.UPDATE_INSIGHT360_PERSONA_LABEL,
              data: {
                personaLabel,
                personaLabelID,
                defId: response.data.data.defId,
                indexToUpdate,
              },
            });
          } else {
            let baseLabel = '';
            let baseExpression = '';
            response.data.data.expressions.map(expression => {
              if (data.expressions[0].title === expression.title) {
                baseLabel = expression.title;
                baseExpression = expression.expression;
              }
            });
            dispatch({
              type: types.SAVE_BRAND_INSIGHT360_BASE_INFO,
              payload: {
                baseLabel,
                baseExpression,
              },
            });
          }
          callbackFnForDefinition();
          return callbackFn(true);
        }
        if (response.status === 400) {
          toastWarning(response.data.message);
          callbackFn(false);
        }
      })
      .catch(response => {
        console.warn(response);
        callbackFn(false);
      });
  };
};

export const saveAttitudinalTemplate = (
  token,
  uid,
  accountId,
  productNo,
  data,
  selectedExpressionObject,
) => {
  const url = `${
    urls.ROOT_URL
  }/si360/user-stmt-template/${uid}/${accountId}/${productNo}`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          const savedAttitudinalData = {
            value: data[0].name,
            label: data[0].name,
            children: selectedExpressionObject,
          };
          dispatch({
            type: types.SAVE_ATTITUDINAL_TEMPLATE_DATA,
            data: savedAttitudinalData,
          });

          toastSuccess(ATTITUDINAL_TEMPLATE_NAME_SAVE_SUCCESS);
        }
        if (response.status === 400) {
          toastWarning(response.data.message);
        }
      })
      .catch(response => {
        console.warn(response);
      });
  };
};

export function validateHeaderInfo({
  token,
  uid,
  accountId,
  personaLabels,
  personaExpressions,
  reportName,
  productNo,
}) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        reportName,
        personaLabels,
        personaExpressions,
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      },
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 400 && _.isEmpty(response.data.data)) {
          return response.status;
        } 
          return response.status;
        
      })
      .catch(response => {
        console.warn(response);
      });
  };
}

export const save360SelectedFilters = (data, category, tabInfo) => ({
  type: types.SAVE_360_SELECTED_FILTERS,
  payload: { data, category, tabInfo },
});

export function getCategorySearchList({
  token,
  uid,
  accountId,
  reportName,
  searchText,
}) {
  const url = `${urls.ROOT_URL}/si360/category-search/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const productNo = getState().study.insight360study.pn;
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        reportName,
        productNo,
        searchText,
      },
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          return response.data.data;
        }
        if (response.status === 400) {
          toastWarning(response.data.message);
        }
      })
      .catch(response => {
        console.warn(response);
      });
  };
}

export const showDeepDivePopup = (value, deepDiveDetails = {}) => ({
  type: types.SHOW_DEEP_DIVE_POPUP,
  value,
  deepDiveDetails,
});


export const showBCCofigurationScreen = flag => ({
  type: types.SHOW_BC_CONFIG_SCREEN,
  payload: { show: flag },
});


export function getDeepDiveDetails(
  { token,
  uid,
  accountId,
  productNo,
  personaLabels,
  personaExpressions,
  reportName,
  level,
  pct,
  base,
  top = 15,
  category,
  selectedTab,
  resolve,
  }) {
  const url = `${urls.ROOT_URL}/catalyst/deep-dive/data-request/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const data = {
      reportName,
      productNo,
      personaLabels,
      personaExpressions,
      baseLabel: (base !== undefined) ? base.baseLabel : undefined,
      baseExpression: (base !== undefined) ? base.baseExpression : undefined,
     // filterConfig: getFilterConfig(getState(), reportName),
      filterConfig: {
        sample: '>0',
        pct: '>0',
        index: '>0',
      },
      top,
      category,
      level,
    };
    data.sortBy = getDeepDiveSortByKey(reportName, getState(), selectedTab);
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
  .then(response => {
    resolve(response.data.data.results);
  })
  .catch(error => {
    console.log(`some error occured for this${error}`);
  });
  };
}

export function exportBrandCatalystReport({
  uid,
  accountId,
  productNo,
  warningType,
  personaLabels,
  personaExpressions,
  reportName,
  base,
  questions,
  sortOrder,
  sortBy,
  sortIdx,
  colorPrefs,
  questionLabel,
  reportRows,
  fileName,
  }) {
  const url = `${urls.ROOT_URL}/reports/exportbcreport/${uid}/${accountId}`;
  const data = {
    reportName,
    productNo,
    warningType,
    personaLabels,
    personaExpressions,
    baseLabel: (base !== undefined) ? base.baseLabel : undefined,
    baseExpression: (base !== undefined) ? base.baseExpression : undefined,
    filterConfig: {
      sample: '>0',
      pct: '>0',
      index: '>0',
    },
    questions,
    sortOrder,
    sortBy,
    sortIdx,
    colorPrefs,
    questionLabel,
    reportRows,
    fileName,
  };
  return () => axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data,
    validateStatus: status => status >= 200 && status < 501,
  })
  .then(response => {
    if (response.status === 200) {
      return response.data.data;
    }
    if (response.status === 400) {
      toastWarning(response.data.message);
    }
    return null;
  })
  .catch(error => {
    console.warn(`some error occured for this${error}`);
  });
}

export function setBrandCatalystPreferenceData(preferenceData) {
  return ({
    type: types.SET_BRAND_CATALYST_PREFERENCE_DATA,
    data: preferenceData,
  });
}

export const saveBrandCatalystSessionData = (preferenceData, sessionPref = false) => {
  return (dispatch, getState) => {
    setBrandCatalystDataOnSave(preferenceData, dispatch, getState, sessionPref);
  };
};


export function getProfileAttitudeStatements(productNo, callback) {
  const url = `${urls.ROOT_URL}/si360/profile-attitudes/${productNo}`;
  return (dispatch, getState) => {
    return axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        if (response.status === 200) {
          callback(response.data.data);
          return true;
        }
        toastWarning('Failed to save preferences');
        return false;
      })
      .catch(response => {
        console.warn(response);
      });
  };
}

export const setSectionSortKey = data => ({
  type: types.SET_SECTION_SORT_KEY,
  payload: data,
});
